import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './CaseFile.css';

const fontsUrl = 'https://fonts.googleapis.com/css2?family=Special+Elite&family=Libre+Franklin:ital,wght@0,400;0,600;0,800;1,400&display=swap';

const MESSAGES = {
  loading: {
    heading: 'Opening the case file…',
    text: null
  },
  no_current_case: {
    heading: 'No case is open right now',
    text: 'The next Sam Norris case file is on its way. Check back soon.'
  },
  not_found: {
    heading: "That case file couldn't be found",
    text: "The link may be out of date, or the case hasn't been released yet.",
    link: true
  },
  archive: {
    heading: 'This case is in the subscriber archive',
    text: 'Past cases open up for subscribers. The newest case is always free.',
    link: true
  },
  default: {
    heading: 'Something went wrong opening the case file',
    text: 'Please try again in a moment.',
    link: true
  }
};

const CaseNotice = ({ code }) => {
  const message = MESSAGES[code] || MESSAGES.default;

  return (
    <div className="case-file-page">
      <Helmet>
        <title>Case File | Jerry Evanoff</title>
        {code !== 'loading' && <meta name="robots" content="noindex" />}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link rel="stylesheet" href={fontsUrl} />
      </Helmet>

      <main className="cf-folder">
        <span className="cf-tab">CASE FILE</span>
        <h1>{message.heading}</h1>
        {message.text && <p className="cf-brief">{message.text}</p>}
        {message.link && (
          <p className="cf-brief">
            <Link to="/case-file">See the current case</Link>
          </p>
        )}
      </main>
    </div>
  );
};

export default CaseNotice;
